import { standLookupOf, standTableOfChunks, type ChunkStand, type StandLookup } from "daedalus-core";

/**
 * Where the booted map draws a character behind or in front of a prop (ADR-132 decision 5): the stand tables every
 * client chunk carries, assembled once into one lookup over the whole map, so asking which side a character's feet
 * are on is one read with no allocation.
 */

/**
 * Assembles a map's stand lookup from its chunks.
 *
 * @param chunkOf A chunk's stand table by its column and row, undefined for a chunk that carries none.
 * @param width Map width in tiles.
 * @param height Map height in tiles.
 * @param chunkSize Chunk size in tiles.
 * @returns The lookup, or null when no chunk carries a table, so a world with no painted prop pays nothing per frame.
 */
export function assembleStand(chunkOf: (cx: number, cy: number) => ChunkStand | undefined, width: number, height: number, chunkSize: number): StandLookup | null {
  const columns = Math.ceil(width / chunkSize);
  const rows = Math.ceil(height / chunkSize);
  const held: { cx: number; cy: number; stand: ChunkStand }[] = [];
  for (let cy = 0; cy < rows; cy += 1) {
    for (let cx = 0; cx < columns; cx += 1) {
      const stand = chunkOf(cx, cy);
      if (stand !== undefined && stand.cells.length > 0) {
        held.push({ cx, cy, stand });
      }
    }
  }
  return held.length === 0 ? null : standLookupOf(standTableOfChunks(held, chunkSize, width, height));
}
